export const ResultCardsEnum = {
  0: 'joker',
  1: 'red_2',
  2: 'black_2',
  3: 'red_3',
  4: 'black_3',
  5: 'red_4',
  6: 'black_4',
  7: 'red_5',
  8: 'black_5',
  9: 'red_6',
  10: 'black_6',
  11: 'red_7',
  12: 'black_7',
  13: 'red_8',
  14: 'black_8',
  15: 'red_9',
  16: 'black_9',
  17: 'red_j',
  18: 'black_j',
  19: 'red_q',
  20: 'black_q',
  21: 'red_k',
  22: 'black_k',
  23: 'red_a',
  24: 'black_a',
};
Object.freeze(ResultCardsEnum);
